"use client"

import { useState, useEffect } from "react"
import { ExternalLink } from "lucide-react"

const Speakers = () => {
  const [expandedSpeaker, setExpandedSpeaker] = useState(null)
  const [currentAdIndex, setCurrentAdIndex] = useState(0)

  // Real sponsors data
  const sponsors = {
    speakers: [
      {
        name: "Ethiopian Airlines",
        logo: "/assets/images/airliness.png",
        tagline: "Africa's Largest Aviation Group",
        description: "Connecting Africa to the world with excellence in aviation services.",
        website: "https://www.ethiopianairlines.com/",
        category: "Aviation",
      },
      {
        name: "Ministry of Transport & Logistics",
        logo: "/assets/images/MoTL.jpg",
        tagline: "Building Ethiopia's Future",
        description: "Developing transportation infrastructure and logistics policies.",
        website: "https://www.motl.gov.et/",
        category: "Government",
      },
      {
        name: "Ethiopian Maritime Training Institute",
        logo: "/assets/images/emtisc.jpg",
        tagline: "Training Tomorrow's Leaders",
        description: "World-class maritime education and professional training programs.",
        website: "https://emticorp.com/",
        category: "Education",
      },
    ],
  }

  // Auto-rotate ads
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAdIndex((prev) => (prev + 1) % sponsors.speakers.length)
    }, 7000)
    return () => clearInterval(interval)
  }, [sponsors.speakers.length])

  const toggleSpeakerDetails = (index) => {
    setExpandedSpeaker(expandedSpeaker === index ? null : index)
  }

  const speakers = [
    {
      id: 1,
      name: "Dr. Alemu Sime Feyisa",
      title: "Minister of Transport and Logistics",
      organization: "Ministry of Transport & Logistics, Ethiopia",
      secondLine: "",
      image: "/assets/images/mr-alemu.png",
      bio: `Dr. Alemu Sime is a transformative leader at the helm of Ethiopia’s Ministry of Transport and Logistics. Under his guidance, the ministry is spearheading ambitious projects to modernize the nation's transport infrastructure, including the electrification of the Addis Ababa–Djibouti Railway, the development of the Adama–Awash Expressway, and the promotion of green mobility initiatives. These efforts are central to Ethiopia’s strategy to enhance regional connectivity, stimulate economic growth, and position the country as a logistics hub in Africa.`,
      revealed: true,
    },
    {
      id: 2,
      name: "Ester Magano Nangolo",
      title: "Regional Vice President, WOMESA • Senior Fisheries Biologist",
      organization: "Ministry of Agriculture, Fisheries, Water and Land Reform, Walvis Bay, Namibia",
      secondLine: "",
      image: "/assets/images/Ester.png",
      bio: `Ms. Ester Magano Nangolo works as a Senior Fisheries Biologist in Walvis Bay, Namibia, where she contributes to aquatic resource assessment and monitoring under the National Marine Information Research Center. She holds a Bachelor of Science (Honours) in Fisheries and Aquatic Sciences from the University of Namibia and a Master of Education in Environmental Education from Rhodes University. 
          In addition to her technical work, she serves as Regional Vice President of WOMESA (Women in Maritime Eastern and Southern Africa), where she plays a crucial role in advocating for gender equity within the maritime sector, helping to elevate women’s participation in training, leadership, and decision-making at regional levels.`,
      revealed: true,
    },
    {
      id: 3,
      name: "Francois Joubert",
      title: "Chief Executive Officer",
      organization: "CEO at YCF Manning",
      bio: `Francois Joubert is the Chief Executive Officer of YCF Manning, a global crew management company that owns and oversees the Ethiopian Maritime Training Institute (EMTI). Under his leadership, YCF Manning has strengthened its commitment to developing top-tier African maritime professionals, with EMTI standing as a flagship initiative for high-quality training and deployment.

With a strong focus on workforce development, capacity building, and international standards, Joubert has played a pivotal role in shaping YCF’s strategy to address the global demand for competent seafarers. His leadership has led to the successful deployment of thousands of well-trained Ethiopian officers and ratings to vessels around the world, enhancing both the visibility and reputation of African talent in the maritime sector.

By bridging global industry requirements with localized excellence in training, Joubert continues to position YCF Manning and EMTI as catalysts for long-term growth and transformation within Africa’s maritime landscape.`,
      image: "/assets/images/speaker-2.jpg",
      revealed: true,
    },
    {
      id: 4,
      name: "Captain Kishor Shingare",
      title: "Training",
      organization: "Seaspan Crew Management",
      bio: `Captain Kishor Shingare is a seasoned maritime professional with over two decades of experience in nautical operations and crew development. Since 2011, he has led training initiatives at Seaspan Crew Management in Mumbai, focusing on preparing seafarers for service across the company's global fleet. Prior to Seaspan, he held senior roles in maritime training and operations, building a deep understanding of seafarer development and industry best practices. He will participate in the Global Shipping Perspectives session at the conference, which brings together leading international shipowners, operators, and management firms to discuss trends in global crewing, maritime operations, and Africa's role in the global shipping workforce.`,
      image: "/assets/images/kishar.jpg",
      revealed: true,
    },
    {
      id: 5,
      name: "George Novak",
      title: "Vice President, ",
      organization: "Commercial Services, LISCR (The Liberian Registry)",
      bio: `George Novak serves as Vice President of Commercial Services at the Liberian International Ship & Corporate Registry (LISCR), where he supports one of the world’s leading ship registries in delivering regulatory, technical, and commercial services to the global maritime community. With a background spanning ship operations, engineering, and advisory roles, his career includes leadership positions at Serco, Gartner, and Fairbanks Morse Defense, as well as seagoing experience as a Third Assistant Engineer. George holds a degree in Marine Engineering from the United States Merchant Marine Academy and an MBA from Georgetown University’s McDonough School of Business. His expertise bridges technical operations and commercial strategy, making him a strong voice in discussions on global shipping and workforce development.`,
      image: "/assets/images/George.jpg",
      revealed: true,
    },
    {
      id: 6,
      name: "Captain Charl Coetzee",
      title: "Commandant",
      organization: "Ethiopian Maritime Training Institute (EMTI)",
      bio: `Captain Charl Coetzee brings over three decades of naval and maritime training expertise to EMTI. A distinguished officer of the South African Navy, he spent 30 years at sea, serving onboard submarines and surface ships—including nearly eight years as Commanding Officer of SAS Outeniqua and SAS Drakensberg. He also played a pivotal role in officer education at the SA Naval College and the Maritime Warfare Training Centre. Since joining EMTI in 2014 and assuming the role of Commandant in 2019, Capt. Coetzee has driven the development and accreditation of EMTI’s training programs and Quality Management Systems, helping to shape the future of maritime education in Africa.`,
      image: "/assets/images/charl.jpg",
      revealed: true,
    },
    {
      id: 7,
      name: "Stewart Bankier",
      title: "Director of Crewing Training",
      organization: "Columbia Shipmanagement (CSM)",
      bio: `Stewart Bankier is an accomplished leader in maritime training and people development, currently serving as Director of Crewing Training at Columbia Shipmanagement (CSM). With a high-ranking naval background and decades of experience in maritime operations, Stewart brings a unique blend of strategic insight and human-centered leadership to crew training and safety culture.

At CSM, he oversees training policies, systems, and innovation across a fleet of 400+ vessels, driving global crewing strategies and performance improvement initiatives. He has led transformative programs, including the rollout of a Cadet Training Management System for over 800 cadets and the design of a Competence Assessor course delivered to more than 3,000 senior seafarers—initiatives that directly supported multi-million-dollar chartering opportunities.

Known for championing the “human element” of maritime safety and embedding a Just Culture, Stewart is a collaborative leader who inspires excellence, operational discipline, and continuous development across all levels of shipboard and shoreside teams.`,
      image: "/assets/images/Stewart.png",
      revealed: true,
    },
    {
      id: 8,
      name: "Dr. Inga Bartuseviciene",
      title: "Associate Professor",
      organization: " World Maritime University",
      bio: `Dr. Inga Bartuseviciene is an Associate Professor at the World Maritime University (WMU) in Malmö, Sweden, where she focuses on maritime education, training, and learning innovation. She holds an MSc in Mathematics, an MSc in Maritime Affairs (Maritime Education and Training) from WMU, and a PhD in Education Sciences from Klaipėda University, Lithuania.
            Before joining WMU, Dr. Bartuseviciene spent nearly two decades at the Lithuanian Maritime Academy, including six years as Deputy Director for Academic Affairs. In this role, she contributed to more than 20 EU-funded projects that modernized educational infrastructure, introduced advanced simulators, and expanded international partnerships.
            Her teaching and research emphasize transformative education, improved learning outcomes, and the essential role of people in building a resilient and sustainable maritime workforce. She is an active contributor to international conferences and collaborative projects, advancing the dialogue on the future of maritime education and training.
            `,
      image: "/assets/images/Inga.png",
      revealed: true,
    },
     {
      id: 9,
      name: "Kenneth A. Epidei",
      title: "Managing Director & CEO",
      organization: " World Maritime University",
      bio: `Kenneth A. Epidei is an accomplished maritime professional and the Managing Director & CEO of Joemarine Institute of Nautical Studies and Research in Nigeria. He holds a Bachelor of Science in Marketing from the Regional Maritime University, Ghana, along with professional training at the Mumbai Maritime Training Institute in India.
          With extensive experience across the marine, oil, and gas industries, Mr. Epidei has led and contributed to a wide variety of projects, with a strong focus on training and development of mariners. He is recognized for his expertise in contract administration, workforce development, and project execution, as well as his ability to mentor and lead in fast-paced environments.
          At Joemarine Institute, Kenneth continues to advance maritime education and capacity building, bringing together technical knowledge, leadership, and a commitment to excellence to strengthen the future of the industry in Nigeria and beyond.
            `,
      image: "",
      revealed: true,
    },
    {
      id: 8,
      name: "West Africa Maritime Training Academies",
      title: "West Africa",
      organization: "Maritime Education Network",
      image: "/patterns/AMC_Blue Pattern-8.png",
      revealed: true,
    },
    {
      id: 9,
      name: "South African Maritime Training Academies",
      title: "Southern Africa",
      organization: "Maritime Education Network",
      
      image: "/patterns/AMC Pattern Color-8.png",
      revealed: true,
    },
    {
      id: 10,
      name: "East Africa Maritime Training Academies",
      title: "East Africa",
      organization: "Maritime Education Network",
      
      image: "/patterns/AMC Gradient Pattern-8.png",
      revealed: true,
    },
    {
      id: 11,
      name: "North Africa Maritime Training Academies",
      title: "North Africa",
      organization: "Maritime Education Network",
      
      image: "/patterns/AMC Gradient Pattern-8.png",
      revealed: true,
    }
  ]

  // Ad Components
  const SpeakerBannerAd = ({ sponsor }) => {
    const getCategoryColor = (category) => {
      switch (category) {
        case "Government":
          return "from-blue-600 to-blue-800"
        case "Education":
          return "from-green-600 to-emerald-700"
        case "Aviation":
          return "from-purple-600 to-indigo-700"
        default:
          return "from-gray-600 to-gray-800"
      }
    }

    return (
      <div className="mb-12">
        <div className={`bg-gradient-to-r ${getCategoryColor(sponsor.category)} rounded-lg shadow-lg overflow-hidden`}>
          <div className="bg-black/20 px-4 py-2 text-xs text-white/80 text-center border-b border-white/10 flex items-center justify-between">
            <span>Proudly Sponsored by {sponsor.category} Partner</span>
            <a
              href={sponsor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
          <div className="flex items-center justify-center p-6">
            <div className="text-center text-white w-full max-w-4xl">
              <div className="flex items-center justify-center mb-4">
                <img
                  src={sponsor.logo || "/placeholder.svg"}
                  alt={sponsor.name}
                  className="h-12 w-auto max-w-[200px] object-cover bg-white/90 rounded px-3 py-2"
                />
              </div>
              <h3 className="font-bold text-xl mb-2">{sponsor.name}</h3>
              <p className="text-white/90 text-lg mb-3">{sponsor.tagline}</p>
              <p className="text-white/80 text-sm max-w-2xl mx-auto">{sponsor.description}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const InlineSpeakerAd = ({ sponsor }) => {
    const getCategoryColor = (category) => {
      switch (category) {
        case "Government":
          return "from-blue-50 to-blue-100"
        case "Education":
          return "from-green-50 to-green-100"
        case "Aviation":
          return "from-purple-50 to-purple-100"
        default:
          return "from-gray-50 to-gray-100"
      }
    }

    return (
      <div className="my-12">
        <div
          className={`bg-gradient-to-r ${getCategoryColor(sponsor.category)} border border-gray-200 rounded-lg p-6 shadow-sm`}
        >
          <div className="flex items-center justify-between mb-4">
            <span className="text-xs text-gray-500 bg-white px-3 py-1 rounded-full">Speaker Series Sponsor</span>
            <span className="text-xs text-gray-400">{sponsor.category}</span>
          </div>
          <div className="flex items-center gap-6">
            <img
              src={sponsor.logo || "/placeholder.svg"}
              alt={sponsor.name}
              className="h-16 w-auto max-w-[120px] object-contain bg-white rounded p-2 shadow-sm"
            />
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-800 mb-2">{sponsor.name}</h3>
              <p className="text-primary-orange font-medium text-sm mb-2">{sponsor.tagline}</p>
              <p className="text-gray-600 text-sm mb-3">{sponsor.description}</p>
              <a
                href={sponsor.website}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-primary-navy hover:bg-primary-navy/90 text-white text-sm px-4 py-2 rounded transition-colors"
              >
                Learn More <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const SponsorRecognition = () => (
    <div className="mt-16 mb-8">
      <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
        <div className="text-center mb-6">
          <h4 className="text-lg font-semibold text-gray-800 mb-2">Speaker Series Partners</h4>
          <div className="h-0.5 w-16 bg-primary-orange mx-auto"></div>
        </div>
        <div className="flex items-center justify-center gap-8 flex-wrap">
          {sponsors.speakers.map((sponsor, index) => (
            <a
              key={index}
              href={sponsor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 hover:opacity-80 transition-opacity group"
            >
              <img
                src={sponsor.logo || "/placeholder.svg"}
                alt={sponsor.name}
                className="h-8 w-auto max-w-[100px] object-contain"
              />
              <div className="hidden sm:block">
                <p className="text-sm font-medium text-gray-700 group-hover:text-primary-navy transition-colors">
                  {sponsor.name}
                </p>
                <p className="text-xs text-gray-500">{sponsor.category}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  )

  const currentSponsor = sponsors.speakers[currentAdIndex]

  return (
    <section
      id="speakers"
      className="py-20 relative overflow-hidden"
      style={{ backgroundColor: "rgba(255, 255, 254, 0.93)" }}
    >
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-navy mb-4">Our Distinguished Speakers</h2>
          <div className="h-1 w-24 bg-gradient-to-r from-primary-orange to-primary-blue mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Learn from industry leaders and visionaries who are shaping the future of maritime in Africa.
          </p>
        </div>

        

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            {speakers.map((speaker, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="relative mb-4 w-48 h-48 flex items-center justify-center">
                  <div className="w-full h-full rounded-full overflow-hidden border-4 border-white shadow-lg flex items-center justify-center bg-gray-100 relative">
                    {speaker.image ? (
                      <>
                        <img
                          src={speaker.image}
                          alt={speaker.name}
                          className={`w-full h-full object-cover ${speaker.image.includes('patterns/') ? 'opacity-10' : 'opacity-100'}`}
                        />
                        {speaker.image.includes('patterns/') && (
                          <div className="absolute inset-0 flex items-center justify-center p-4 text-center">
                            <span className="text-primary-navy font-bold text-lg md:text-xl text-center">
                              {speaker.name}
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="flex flex-col items-center justify-center w-full h-full p-4 text-center">
                        <span className="text-lg font-semibold text-gray-500">{speaker.title}</span>
                      </div>
                    )}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-primary-navy">{speaker.name}</h3>
                <p className="text-primary-green font-medium mb-1">{speaker.title}</p>
                <p className="text-gray-600 text-sm mb-1">{speaker.organization}</p>
                {speaker.secondLine && <p className="text-gray-500 text-sm">{speaker.secondLine}</p>}
                {speaker.revealed && !speaker.name.includes('Academies') && (
                  <div
                    onClick={() => toggleSpeakerDetails(index)}
                    className="mt-3 flex items-center gap-1 text-primary-blue cursor-pointer hover:text-primary-orange transition-colors"
                  >
                    <span className="text-sm font-medium">More info</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`transform transition-transform ${expandedSpeaker === index ? "rotate-180" : ""}`}
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                )}
                {expandedSpeaker === index && speaker.revealed && (
                  <div className="mt-4 bg-gray-50 p-4 rounded-lg border border-gray-100 text-left animate-fadeIn">
                    <p className="text-gray-700 mb-3">{speaker.bio}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Inline Ad after speakers */}
          <InlineSpeakerAd sponsor={sponsors.speakers[1]} />

          {/* Sponsor Recognition Section */}
          <SponsorRecognition />

          <div className="mt-8 text-center">
            <p className="text-primary-navy font-medium">
              More distinguished speakers will be announced in the coming weeks.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Speakers
